<template>
  <v-dialog
    scrollable
    v-model="isOpened"
    content-class="dialog-fullscreen-floating"
  >
    <v-card class="report-image-card">
      <v-card-text class="pa-0" v-if="url">
        <v-row no-gutters justify="center" align="center" class="fill-height">
          <img
            :src="url"
          />
        </v-row>
        <v-btn
          icon
          outlined
          elevation="8"
          color="white"
          @click="isOpened = false"
          style="position: absolute; right: 15px; top: 15px; background-color: rgba(0, 0, 0, .3);"
        >
          <v-icon>close</v-icon>
        </v-btn>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: {
    value: Boolean,
    url: {
      type: String,
      required: false,
    },
  },
  data: () => ({
  }),
  computed: {
    isOpened: {
      get() { return this.value; },
      set(value) { this.$emit(`input`, value); },
    },
  },
  methods: {
  },
};
</script>

<style lang="scss" scoped>
.report-image-card {
  img {
    max-height: 100%;
    max-width: 100%;
    width: 100%;
    object-fit: contain;
  }
}
</style>
